module.exports = __webpack_public_path__ + "assets/icon-formatting-help.63a06a4e.svg";